// Setter function to store a value in localStorage
export function setSessionStorageItem(key, value) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // Handle potential errors when storing the value
    console.error(`Error storing ${key} in localStorage: ${error}`);
  }
}
